import { Sender } from 'xstate';

import config from '@/config';
import asyncCallback from '@/framework/logic/utils/asyncCallback';
import { LogicContext } from '@/logic/main/types';
import { fetchJackpotsV2Multiple } from '@/model/jackpotsV2';
import { JackpotProvidersUnion } from '@/types/jackpotTypes';

import { JackpotFeedsData } from './fetchJackpotFeeds';

const intervalIds: Record<
  string,
  ReturnType<typeof setInterval> | undefined
> = {};

export const watchJackpotsFeed = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'JACKPOT_FEEDS_UPDATED';
        data: JackpotFeedsData;
      }>
    ) => {
      const jackpots = context.jackpots;

      if (!jackpots || Object.keys(jackpots).length === 0) {
        return () => {};
      }

      const currency = context.user?.currency || config.default_currency;
      const intervalsConfig = config.intervals.jackpots.multiple;

      Object.entries(jackpots).forEach(([provider, byCodes]) => {
        if (!provider || !(provider in intervalsConfig)) {
          return;
        }

        if (intervalIds[provider]) {
          clearInterval(intervalIds[provider]);
        }

        const interval = intervalsConfig[provider as keyof typeof intervalsConfig];

        if (!interval || interval <= 0) {
          console.warn(
            `Invalid interval: ${interval} for provider ${provider}, skipping...`
          );
          return;
        }

        try {
          const codes = Object.keys(byCodes);

          const intervalId = setInterval(async () => {
            const data = await fetchJackpotsV2Multiple({
              currency,
              gamesJackpotCodes: codes,
              provider: provider as keyof typeof intervalIds,
            });

            callback({
              type: 'JACKPOT_FEEDS_UPDATED',
              data: {
                data: [
                  {
                    provider: provider as JackpotProvidersUnion,
                    data,
                  },
                ],
              },
            });
          }, interval);

          intervalIds[provider] = intervalId;
        } catch (error) {
          console.error(`Error fetching jackpots for provider ${provider}:`, error);
        }

        
      });

      return () => {
        Object.values(intervalIds).forEach(
          intervalId => intervalId && clearInterval(intervalId)
        );
      };
    }
  );
